import axiosInst from '../../libs/axios/axios'
import axios from 'axios'
import router from '../../router'
import VueJwtDecode from 'vue-jwt-decode'
const auth_axios = axios.create({ timeout: process.env.VUE_APP_TIME_OUT })

const state = {
  token: localStorage.getItem('token') || '',
  refresh: localStorage.getItem('refresh') || '',
  userInfo: {},
  rootUrl: process.env.VUE_APP_ROOT_URL,
  timeOut: process.env.VUE_APP_TIME_OUT,
  motion: false,
  interceptor: null,
  refreshCount: 1,
  role:'user'
}
const getters = {
  loggedIn (state) {
    return state.token !== ''
  },
  returnUserInfo (state) {
    return state.userInfo
  },
  returnGetMotion (state) {
    return state.motion
  },
  userRole (state) {
    return state.role
  } 

}
const mutations = {
  loggedIn (state, token) {
    state.token = token
  },
  destroyToken (state) {
    state.token = null
  },
  userInfo (state, info) {
    state.userInfo = info
  },
  role (state, info) {
    state.role = info
  },
  motion (state) {
    state.motion = true
  },
  interceptor (state, info) {
    state.interceptor = info
  },
  refreshCount (state, info) {
    state.refreshCount = info
  },
  incrementRefreshCount (state) {
    state.refreshCount += 1
  },
  clearRefreshCount (state) {
    state.refreshCount = 1
  }
}


const actions = {

  motionGetter (store) {
    store.commit('motion')
  },
  tokenTimeOutForCaution (state, info) {
    state.commit('tokenTimeOutForCaution', info)
  },

  userInfo (store, info) {
    localStorage.setItem('userInfo', JSON.stringify(info))
    store.commit('userInfo', info)

    let role = 'user'

    if (info.is_super === true) {
      role = 'is_super'
    } else if (info.is_super === false && info.tenant_master === true) {
      role = 'tenant_master'
    } else if (info.is_super === false && info.tenant_master === false) {
      role = 'user'
    }  else {
      role = 'user'
    }
    store.commit('role', role)
  },

  activateControl (_, info) {
    return new Promise((resolve, reject) => {
      auth_axios.get(`${state.rootUrl  }/api/user/activate/${  info  }/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  register (_, data) {
    return new Promise((resolve, reject) => {
      auth_axios.post(`${state.rootUrl  }/api/user/register/`, {
        username: data.email,
        password: data.password,
        first_name: data.first_name,
        last_name: data.last_name,
        user_agreement_approved: data.user_agreement_approved,
        privacy_agreement_approved: data.privacy_agreement_approved,
        cookie_agreement_approved: data.cookie_agreement_approved
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  recoverPassword (_, email) {
    return new Promise((resolve, reject) => {
      const emailPackage = new FormData()
      emailPackage.append('username', email)

      auth_axios.post(`${state.rootUrl  }/api/user/password-reset/`, emailPackage).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  passwordReset (_, password) {
    return new Promise((resolve, reject) => {
      const passwordPackage = new FormData()
      passwordPackage.append('password', password.password)
      passwordPackage.append('token', password.token)

      auth_axios.post(`${state.rootUrl  }/api/user/password-reset/confirm/`, passwordPackage).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updatePassword (_, passwordInfo) {
    const data = {
      'old_password': passwordInfo[0],
      'new_password': passwordInfo[1]
    }
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/user/password-change/`, data, {
        headers: {
          'Authorization': `Bearer ${  localStorage.getItem('token')}`
        },
        timeout: state.timeOut
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  retrieveToken (store, info) {
    return new Promise((resolve, reject) => {
      auth_axios.post(`${state.rootUrl  }/api/user/token/`, info).then(response => {
        localStorage.setItem('token', response.data.access)
        localStorage.setItem('refresh', response.data.refresh)
        const token = VueJwtDecode.decode(response.data.access)
        store.dispatch('userInfo', token)
        axiosInst.defaults.headers['Authorization'] = `Bearer ${  response.data.access}`
        store.dispatch('axiosInterceptor')
        store.commit('motion')
        store.dispatch('userMeInfo')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  axiosInterceptor (store) {
    const iceptor = axiosInst.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.response.status !== 401) {
          if (error.response.status === 503) {
            router.push('/under-maintenance')
          } else {
            return new Promise((resolve, reject) => {
              reject(error)
            })
          }
        }


        if (error.config.url === `${state.rootUrl  }/api/user/token/refresh/`) {
          return new Promise((resolve, reject) => {
            store.dispatch('destroyToken')
            store.commit('clearRefreshCount')
            router.push('/login').catch(() => { })
            reject(error)
          })
        }

        if (state.refreshCount === 20) {
          return new Promise((resolve, reject) => {
            store.dispatch('destroyToken')
            store.commit('clearRefreshCount')
            router.push('/login').catch(() => { })
            reject(error)
          })
        }
        if (error.response.status === 401) {
          return store.dispatch('refreshToken').then(token => {
            const config = error.config
            localStorage.setItem('token', token.data.access)
            axiosInst.defaults.headers['Authorization'] = `Bearer ${  token.data.access}`
            config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`
            store.commit('incrementRefreshCount')
            store.commit('motion')
            return new Promise((resolve, reject) => {
              axiosInst.request(config).then(response => {
                store.commit('clearRefreshCount')
                resolve(response)
              }).catch(error => {
                store.commit('clearRefreshCount')
                reject(error)
              })
            })
          }).catch((error) => {
            return new Promise((resolve, reject) => {
              reject(error)
            })
          })
        }
      }
    )
    store.commit('interceptor', iceptor)
  },
  deleteAxiosInterceptor (store) {
    if (state.interceptor !== null || state.interceptor !== undefined) {
      axiosInst.interceptors.request.eject(state.interceptor)
      store.commit('interceptor', null)
    }
  },

  destroyToken (store) {
    localStorage.removeItem('userInfo')
    localStorage.removeItem('token')
    localStorage.removeItem('refresh')
    localStorage.removeItem('remember')
    localStorage.removeItem('userMeInfo')
    store.dispatch('deleteAxiosInterceptor')
  },
  refreshToken (store) {
    return new Promise((resolve, reject) => {
      axiosInst.post(`${state.rootUrl  }/api/user/token/refresh/`, {
        refresh: localStorage.getItem('refresh')
      }).then(response => {
        localStorage.setItem('token', response.data.access)
        const token = VueJwtDecode.decode(response.data.access)
        store.dispatch('userInfo', token)
        resolve(response)
      }).catch((error) => {
        store.dispatch('destroyToken')
        router.push('/login').catch(() => { })
        reject(error)
      })
    })
  },

  getPolicy (store, filter) {
    return new Promise((resolve, reject) => {
      auth_axios.get(`${state.rootUrl  }/api/policy/${  filter}`).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  logout () {
    return new Promise((resolve, reject) => {
      axiosInst.post(`${state.rootUrl  }/api/user/token/logout/`, {
        refresh_token: localStorage.getItem('refresh')
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  apiSuccessCheck () {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/check`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
